<template>
  <figure ref="headerAnim">
    <!-- <img
      src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg' viewBox%3D'0 0 975 562'%2F%3E"
    > -->
  </figure>
</template>

<style scoped>
  figure {
    text-align: center;
    pointer-events: none;
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
</style>

<script lang="ts" setup>
import lottie from 'lottie-web/build/player/lottie_light';
import { onMounted, ref, onBeforeUnmount, nextTick } from 'vue';

let curProportion = 0;
let anim: any; // lottie animation

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  rawAnimData: {
    type: Object,
    required: true,
  }
})

const headerAnim = ref<HTMLDivElement>(null)

onMounted(() => {
  windowWidthListener(null, true)
  nextTick(() => {
    window.addEventListener('resize', windowWidthListener)
  })
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', windowWidthListener)
})

function getImageProportion(width: number) {
  if (width > 2200)
    return 4
  else if (width > 1195)
    return 2
  return 1
}

function windowWidthListener(evt: Event | null, first = false) {
  const newVal = window.innerWidth
  const newProportion = getImageProportion(newVal)
  console.log(`newVal: ${ newVal } newProportion: ${ newProportion }`)
  if (!curProportion || newProportion > curProportion) {
    loadAnimation(newProportion, first)
  }
  curProportion = newProportion
}

// check_webp_feature:
//   'feature' can be one of 'lossy', 'lossless', 'alpha' or 'animation'.
//   'callback(feature, isSupported)' will be passed back the detection result (in an asynchronous way!)
function check_webp_feature(feature): Promise<boolean> {
  return new Promise(callback => {
    const kTestImages = {
        // lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
        // lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
        alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
    };
    const img = new Image();
    img.onload = function () {
        const result = (img.width > 0) && (img.height > 0);
        callback(result);
    };
    img.onerror = function () {
        callback(false);
    };
    img.src = "data:image/webp;base64," + kTestImages[feature];
  })
}

// this is pretty slow (~300ms in Chrome as of 2/12/2022)
check_webp_feature('alpha').then((res) => {
  // fallback to png
  if (!res)
    loadAnimation(curProportion, false, false);
});


function loadAnimation(proportion: number, first = false, webp = true) {
  console.log('reloading anim with ' + proportion)
  if (anim)
    anim.destroy()

  if (!window.__PRERENDER_INJECTED?.isPrerendering) {
    const animationData = {
      ...props.rawAnimData,
      assets: props.rawAnimData.assets.map(asset => {
        if (asset.u)
          return {
            ...asset,
            u: `/anim-v4/${asset.u.replace('/', `_${proportion}x/`)}`,
            p: `${asset.p.slice(0, -3)}${webp ? 'webp' : 'png'}`,
          }
        return asset;
      })
    };

    anim = lottie.loadAnimation({
      container: headerAnim.value,
      // path: `/assets/anim/${ props.name }${ proportion > 1 ? '-' + proportion + 'x' : '' }.json`,
      animationData,
      renderer: 'svg',
      loop: true,
      autoplay: true,
    })
  }

  // if (first) {
  //   // hack to clear initial frame
  //   anim.addEventListener('data_ready', () => {
  //     console.log('clearing shits')
  //     // headerAnim.value.removeChild(headerAnim.value.firstChild!)
  //   })
  // }
}
</script>
